export default {
  computed: {
    elevationMount () {
      const elevMountType = this.safetySystem == 'SAFE' ? 'elevationMountSafe' : 'elevationMountPW';
      let product = this.products.find(p => p.type === elevMountType);
      let variant = product.variants.find(v => v.color == this.selections.accessoryColor.value);
      let fullProduct = {...product, ...variant};
      delete fullProduct.variants;
      
      if (this.safetySystem == 'SAFE') {
        let amount = this.amountOfProducts(this.selections.roofSafetyRaisedLengths.value, fullProduct["length"]/1000);
        fullProduct.amount = amount;

        let bigpack = this.bigpack(fullProduct, amount);
        fullProduct.singlepack = bigpack[0];
        fullProduct.bigpack = bigpack[1];
      } else { // PW
        let amount = this.snowSafetyConsole.raisedAmount;
        fullProduct.amount = amount;
        fullProduct.singlepack = amount;
      }

      // fullProduct.pallets =  1,
      // fullProduct.totalWeight =  2,
      // fullProduct.values =  1,
      fullProduct.unit = 'st';
      fullProduct.sort = 2;

      return fullProduct;
    },
  },
  methods: {}
}
